export enum RangeValue {
  HUNDRED_PERCENT = 100,
  STEP = 1,
}
